export const GET_DEVICE_UPGRADE_DATA_FROM_API = 'GET_DEVICE_UPGRADE_DATA_FROM_API';
export const DEVICE_UPGRADE_SUCCESS = 'DEVICE_UPGRADE_SUCCESS';
export const DEVICE_UPGRADE_ERROR = 'DEVICE_UPGRADE_ERROR';

export const CREATE_CART_SUCCESS = 'CREATE_CART_SUCCESS';
export const CREATE_CART_ERROR = 'CREATE_CART_ERROR';
export const GET_CREATE_CART_DATA_FROM_API = 'GET_CREATE_CART_DATA_FROM_API';

export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const request = {
  intent: 'EUP_5G',
};
